export enum DeliveryMode {
  Internal = 'internal',
  External = 'external',
}

export enum DeliveryProvider {
  Standalone = 'standalone',
  FirstDelivery = 'first_delivery',
  UberDrive = 'uber_drive',
  WoltDrive = 'wolt_drive',
}

export enum DeliveryStatus {
  Pending = 'pending',
  RunnerAssigned = 'runner_assigned',
  OnRoutePickup = 'en_route_pickup',
  ArrivedPickup = 'arrived_pickup',
  PickedUp = 'picked_up',
  OnRouteDropoff = 'en_route_dropoff',
  ArrivedDropoff = 'arrived_dropoff',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum DeliveryZoneGeometryType {
  Circle = 'circle',
  Polygon = 'polygon',
  Zip = 'zip',
}

export enum DropoffAction {
  RingDoorBell = 'ring_door_bell',
  Sms = 'sms',
}

export enum PaymentMethod {
  Cash = 'cash',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
  PaypalStandalone = 'paypal_standalone',
  Card = 'card',
  Paypal = 'paypal',
  Sofort = 'sofort',
  Giropay = 'giropay',
  SepaDebit = 'sepa_debit',
  BacsDebit = 'bacs_debit',
}

export enum CouponType {
  Reward = 1,
  Cashback = 2,
  PromoCode = 3,
  BogoCampaign = 4,
}

export enum PromoCodeType {
  SingleUse = 'single_use',
  MultiUse = 'multi_use',
}

export enum PromoCodeDiscountType {
  FixedAmount = 'single_use',
  Percentage = 'percentage',
}

export enum OrderMethod {
  Pickup = 'pickup',
  Delivery = 'delivery',
  OnSite = 'room_service',
  DineIn = 'dine_in',
}

export enum OrderPaymentType {
  Online = 'online',
  InStore = 'in_store',
}

export enum OrderPaymentStatus {
  Pending = 'pending',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
}

export enum OrderFulfillmentStatus {
  Created = 'created',
  Reviewed = 'reviewed',
  Accepted = 'accepted',
  Preparing = 'preparing',
  Ready = 'ready',
  OnDelivery = 'on_delivery',
  Picked = 'picked',
  Rejected = 'rejected',
}

export enum OrderScheduleOption {
  Asap = 'asap',
  Scheduled = 'scheduled',
}

export enum ProductIdentifier {
  Vegan = 'vgn',
  Vegetarian = 'vgt',
  GlutenFree = 'gf',
  DairyFree = 'df',
  Halal = 'hal',
  Spicy = 'h&s',
}
